import { State } from '../../type'
import { moduleName } from './constants'
import { RejectedInvoicesState } from './types'

const getState = (state: State): RejectedInvoicesState => state[moduleName]

export const getChangedLines = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.changedLines
}

export const getFetchedLines = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.list
}

export const getTotal = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.total
}

export const getLoadingMore = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.isLoading
}

export const getRejectedAmount = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.rejectedAmount
}
